module.exports = __webpack_public_path__ + "static/jfp-681b8ca608df85aca77fa50a6d8fa51b.png";